export default {
  notificationReceipts: [],
  notificationReceipt: undefined,
};
